import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { Dialog } from '.';

@Component({ className: 'js-dialog' })
export class DialogComponent {
	constructor(private element: HTMLDialogElement) {
		new Dialog(element);
	}
}
